import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "18", height: "18", x: "3", y: "3", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 8v8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m8.5 14 7-4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m8.5 10 7 4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "SquareAsterisk";
const SquareAsterisk = memo(themed(Icon));
export {
  SquareAsterisk
};
//# sourceMappingURL=square-asterisk.js.map
